import {
  hasNonEmptyTrimmedString,
  toFormBoolean,
  toFormString,
} from "@/lib/utils/formFieldCoercion";
import type { DeepPartial } from "react-hook-form";
import type {
  ContactFormEmailRow,
  ContactFormPhoneRow,
  CreateContactFormValues,
} from "./contactFormSchema";

export { toFormBoolean, toFormString };

export function hasNonEmptyPhoneNumber(phone: { number?: unknown }): boolean {
  return hasNonEmptyTrimmedString(phone.number);
}

export function normalizeContactFormPhoneRow(
  phone: DeepPartial<ContactFormPhoneRow> | undefined,
): ContactFormPhoneRow {
  return {
    id: toFormString(phone?.id),
    number: toFormString(phone?.number),
    extension: toFormString(phone?.extension),
    label: toFormString(phone?.label),
    description: toFormString(phone?.description),
    isPrimary: toFormBoolean(phone?.isPrimary),
    dateModified: toFormString(phone?.dateModified),
  };
}

export function normalizeContactFormEmailRow(
  email: DeepPartial<ContactFormEmailRow> | undefined,
): ContactFormEmailRow {
  return {
    id: toFormString(email?.id),
    address: toFormString(email?.address),
    description: toFormString(email?.description),
    label: toFormString(email?.label),
    isPrimary: toFormBoolean(email?.isPrimary),
    dateModified: toFormString(email?.dateModified),
  };
}

/** `useWatch` returns `DeepPartial` rows; API payloads may use `null` for empty fields. */
export function normalizeContactFormPhones(
  phones: DeepPartial<CreateContactFormValues>["phones"],
): ContactFormPhoneRow[] {
  if (!Array.isArray(phones)) return [];
  return phones.map((phone) => normalizeContactFormPhoneRow(phone));
}

export function normalizeContactFormEmails(
  emails: DeepPartial<CreateContactFormValues>["emails"],
): ContactFormEmailRow[] {
  if (!Array.isArray(emails)) return [];
  return emails.map((email) => normalizeContactFormEmailRow(email));
}
